<template>
  <div class="active-dark bg_color--9">
    <!-- Ambient glow effects -->
    <div class="ambient-glow ambient-glow--top"></div>
    <div class="ambient-glow ambient-glow--bottom"></div>
    <!-- 光标聚光：跟随鼠标的柔和金色光晕（仅桌面端有 hover 的设备） -->
    <div class="cursor-glow" ref="cursorGlow"></div>

    <!-- Start Header Area -->
    <HeaderOnePageTwo />
    <!-- End Header Area -->
    <!-- Start Slider Area (commented out) -->
    <!-- <div class="slider-wrapper poss_relative" id="home">
      <div
        class="slide personal-portfolio-slider slider-paralax slider-style-3 d-flex align-center bg_image bg_image--28"
        ref="parallaxContainer">
        <v-container>
          <v-row>
            <v-col cols="12">
              <div class="text-left inner" ref="parallaxText">
                <span class="subtitle-tag">@doem1997</span>
                <h1 class="heading-title">
                  <span class="name-highlight">I'm Zichen Tian</span> <br />
                  Researcher &<br /> Designer <br />
                  <span class="location-highlight">@ Singapore</span>
                </h1>
                <a class="btn-default btn-border btn-opacity mt--30" @click="scrollToSection('about')">About Me</a>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div> -->
    <!-- End Slider Area -->

    <!-- Start About Area  -->
    <div class="about-area pt--120 bg_color--8" id="about">
      <div class="about-wrapper">
        <div class="container">
          <AboutFour>
            <img slot="thum-img" class="w-100" src="../../assets/images/about/about-8_v2.jpeg" alt="About Images" />
          </AboutFour>
        </div>
      </div>
    </div>
    <!-- Start About Area  -->

    <!-- Start Service Area  -->
    <!-- <div class="service-area creative-service-wrapper pt--120 bg_color--8" id="service">
      <div class="container">
        <v-row>
          <v-col lg="12">
            <div class="text-center section-title mb--30 mb_sm--0">
              <span class="subtitle">What I can do for you</span>
              <h2 class="heading-title">My Awesome Service</h2>
              <p>
                There are many variations of passages of Lorem Ipsum available,
                <br />
                but the majority have suffered alteration.
              </p>
            </div>
          </v-col>
        </v-row>
        <ServiceThree />
      </div>
    </div> -->
    <!-- Start Service Area  -->

    <!-- Start Portfolio Area -->
    <!-- <div class="portfolio-area pt--120 bg_color--8" id="portfolio">
      <v-container>
        <v-row>
          <v-col lg="12">
            <div class="text-center section-title mb--30 mb_sm--0">
              <span class="subtitle">My complete project</span>
              <h2 class="heading-title">My Latest Project</h2>
              <p>
                There are many variations of passages of Lorem Ipsum available,
                <br />
                but the majority have suffered alteration.
              </p>
            </div>
          </v-col>
        </v-row>
        <PortfolioFour />
        <v-row>
          <v-col lg="12">
            <div class="text-center view-more-btn mt--60 mt_sm--30">
              <a class="btn-default" href="#">View Projects</a>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div> -->
    <!-- End Portfolio Area -->

    <!-- Start Blog Area  -->
    <!-- <div class="rn-blog-area pt--120 bg_color--8" id="blog">
      <v-container>
        <v-row align="end" class="mb--20">
          <v-col md="12">
            <div class="text-center section-title">
              <span class="subtitle">Talk Is Cheap, Show Me The Code</span>
              <h2 class="heading-title">Tech Blogs</h2>
            </div>
          </v-col>
        </v-row>
        <Blog />
        <v-row>
          <v-col lg="12">
            <div class="text-center view-more-btn mt--60 mt_sm--30">
              <a class="btn-default" href="/blog">View All Blogs</a>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div> -->
    <!-- End Blog Area  -->

    <!-- Start Contact Area  -->
    <div class="rn-contact-area ptb--120 bg_color--8" id="contact">
      <div class="contact-form--1">
        <v-container>
          <Contact>
            <!-- <img slot="contact-img" class="w-100" src="../../assets/images/about/about-13.jpg" alt="contact images" /> -->
          </Contact>
        </v-container>
      </div>
    </div>
    <!-- End Contact Area  -->

    <!-- Start Footer Area  -->
    <Footer />
    <!-- End Footer Area  -->
  </div>
</template>

<script>
import HeaderOnePageTwo from "../../components/header/HeaderOnePageTwo";
import AboutFour from "../../components/about/AboutFour";
import ServiceThree from "../../components/service/ServiceThree";
import PortfolioFour from "../../components/portfolio/PortfolioFour";
import Blog from "../../components/blog/BlogTwo";
import Contact from "../../components/contact/Contact";
import Footer from "../../components/footer/FooterTwo";

export default {
  components: {
    HeaderOnePageTwo,
    AboutFour,
    ServiceThree,
    PortfolioFour,
    Blog,
    Contact,
    Footer,
  },
  data() {
    return {
      scrollY: 0,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      window.addEventListener('mousemove', this.handleMouseMove, { passive: true });
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('mousemove', this.handleMouseMove);
    if (this.glowRaf) cancelAnimationFrame(this.glowRaf);
  },
  methods: {
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },
    handleMouseMove(e) {
      this.glowTarget = { x: e.clientX, y: e.clientY };
      if (this.glowRaf) return;
      this.glowRaf = requestAnimationFrame(() => {
        this.glowRaf = null;
        const el = this.$refs.cursorGlow;
        if (!el) return;
        el.style.setProperty('--mx', `${this.glowTarget.x}px`);
        el.style.setProperty('--my', `${this.glowTarget.y}px`);
        el.classList.add('is-on');
      });
    },
    handleScroll() {
      this.scrollY = window.scrollY;
      if (this.$refs.parallaxContainer && this.$refs.parallaxText) {
        this.$refs.parallaxContainer.style.transform = `translateY(${this.scrollY * 0.1}px)`;
        this.$refs.parallaxText.style.transform = `translateY(-${this.scrollY * 0.5}px)`;
      }
    }
  }
};
</script>

<style scoped>
/* Adjustments for content - Amber Gold Theme */
.active-dark.bg_color--9 {
  background: linear-gradient(135deg, #0A0908 0%, #12100E 50%, #0A0908 100%);
  position: relative;
  overflow: hidden;
}

/* Cursor glow */
.cursor-glow {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.8s ease;
  background: radial-gradient(520px circle at var(--mx, 50%) var(--my, 30%),
      rgba(212, 165, 116, 0.085) 0%,
      rgba(212, 165, 116, 0.03) 35%,
      transparent 70%);
}

.cursor-glow.is-on {
  opacity: 1;
}

@media (prefers-reduced-motion: reduce) {
  .cursor-glow {
    display: none;
  }
}

/* Ambient glow effects */
.ambient-glow {
  position: fixed;
  pointer-events: none;
  z-index: 0;
}

.ambient-glow--top {
  top: -30%;
  left: -20%;
  width: 80%;
  height: 80%;
  background: radial-gradient(ellipse at center,
      rgba(212, 165, 116, 0.08) 0%,
      rgba(212, 165, 116, 0.03) 30%,
      transparent 70%);
  animation: ambientPulse 8s ease-in-out infinite;
}

.ambient-glow--bottom {
  bottom: -40%;
  right: -20%;
  width: 70%;
  height: 70%;
  background: radial-gradient(ellipse at center,
      rgba(139, 115, 85, 0.06) 0%,
      rgba(139, 115, 85, 0.02) 40%,
      transparent 70%);
  animation: ambientPulse 10s ease-in-out infinite reverse;
}

@keyframes ambientPulse {

  0%,
  100% {
    opacity: 0.6;
    transform: scale(1);
  }

  50% {
    opacity: 1;
    transform: scale(1.1);
  }
}

.slider-wrapper,
.about-area,
.rn-contact-area,
.footer-area {
  position: relative;
  z-index: 1;
}

/* Make sections transparent to show the ambient background */
.about-area,
.rn-contact-area,
.service-area,
.portfolio-area,
.rn-blog-area {
  background-color: transparent !important;
}

/* About area top spacing - account for fixed navbar */
.about-area {
  padding-top: 150px !important;
}

@media (max-width: 767px) {
  .about-area {
    padding-top: 110px !important;
  }
}

.slider-paralax {
  transition: transform 0.1s ease-out;
  will-change: transform;
  background-size: cover;
  background-position: center;
}

.inner {
  transition: transform 0.1s ease-out;
  will-change: transform;
}

/* Typography enhancements */
.subtitle-tag {
  font-weight: 300;
  font-family: var(--font-primary);
  letter-spacing: 2px;
  color: var(--color-body);
  opacity: 0.8;
}

.name-highlight {
  background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-accent-muted) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.location-highlight {
  color: var(--color-secondary);
  opacity: 0.9;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .bg_image--28 {
    background-position: 55% center;
  }

  .ambient-glow--top {
    width: 100%;
    height: 60%;
    top: -20%;
    left: -30%;
  }

  .ambient-glow--bottom {
    width: 100%;
    height: 50%;
    bottom: -30%;
    right: -30%;
  }
}

@media (max-width: 480px) {

  .ambient-glow--top,
  .ambient-glow--bottom {
    opacity: 0.5;
  }
}

.active-dark.bg_color--9 .slide.bg_image--28 {
  background-color: transparent;
}

/* Smooth section transitions */
.about-area,
.rn-contact-area {
  position: relative;
}

.about-area::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 200px;
  background: linear-gradient(to bottom, transparent, rgba(18, 16, 14, 0.3));
  pointer-events: none;
  z-index: 0;
}
</style>
